<template src="./profilo.html"></template>

<script>
import { save_userAccount } from "@/api/api.user.js";

export default {
  props: {
    compCode: { type: String, default: "" },
  },

  data: () => ({
    loading: false,
    e1: false,
    e2: false,
    e3: false,
    validFormUtente: true,
    disabilitaBtnSaveAccount: false,
    alertElaborazione: "",
    tipo: "success",

    datiAccount: {
      Utente: "",
      PasswordAttuale: "",
      Password: "",
      PasswordRepeat: "",
      Mail: "",
      UserId: null,
      Gruppo: "",
      Certificazione: "",
      CertificazioneFSC: "",
      CertificazionePEFC: "",
      CertificazioneFPC: "",
    },
  }),

  methods: {
    caricaDati() {
      this.loading = true;

      this.alertElaborazione = "";
      this.datiAccount.UserId = this.$store.getters["user/getUserId"];
      this.datiAccount.Utente = this.$store.getters["user/getNome"];
      this.datiAccount.Mail = this.$store.getters["user/getMail"];
      this.datiAccount.Gruppo = this.$store.getters["user/getGruppo"];
      this.datiAccount.CertificazioneFSC = this.$store.getters["user/getCertificazioneFSC"];
      this.datiAccount.CertificazionePEFC = this.$store.getters["user/getCertificazionePEFC"];
      this.datiAccount.CertificazioneFPC = this.$store.getters["user/getCertificazioneFPC"];

      this.datiAccount.PasswordAttuale = "";
      this.datiAccount.Password = "";
      this.datiAccount.PasswordRepeat = "";

      //controllo tipo certificazione
      if (this.datiAccount.CertificazioneFSC != null && this.datiAccount.CertificazioneFSC != "" && this.datiAccount.CertificazioneFSC != undefined) this.datiAccount.Certificazione = this.datiAccount.CertificazioneFSC;
      if (this.datiAccount.CertificazionePEFC != null && this.datiAccount.CertificazionePEFC != "" && this.datiAccount.CertificazionePEFC != undefined) {
        if (this.datiAccount.Certificazione != "") this.datiAccount.Certificazione = this.datiAccount.Certificazione + ", " + this.datiAccount.CertificazionePEFC;
        else this.datiAccount.Certificazione = this.datiAccount.CertificazionePEFC;
      }
      if (this.datiAccount.CertificazioneFPC != null && this.datiAccount.CertificazioneFPC != "" && this.datiAccount.CertificazioneFPC != undefined) {
        if (this.datiAccount.Certificazione != "") this.datiAccount.Certificazione = this.datiAccount.Certificazione + ", " + this.datiAccount.CertificazioneFPC;
        else this.datiAccount.Certificazione = this.datiAccount.CertificazioneFPC;
      }

      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    salvaAccount() {
      // Validazione
      if (this.$refs.formPwd.validate() == false) {
        return;
      }

      this.$confirm.open("Salva", "Vuoi salvare i dati?").then((confirm) => {
        if (!confirm) return;
        this.disabilitaBtnSaveAccount = true;

        this.loading = true;
        save_userAccount(this.datiAccount)
          .then((res) => {
            this.alertElaborazione =
              "Dati aggiornati. Per rendere effettive le modifiche uscire e rientrare nell'area riservata.";
            this.tipo = "success";
            this.disabilitaBtnSaveAccount = false;
          })
          .catch((err) => {
            console.log("Profilo.vue " + err);
            this.disabilitaBtnSaveAccount = false;

            this.alertElaborazione = err.response.data.Message;
            this.tipo = "warning";
          });
        this.loading = false;
      });
    },

    refresh() {
      this.caricaDati();
    },
  },

  mounted() {
    this.caricaDati();
  },

  watch: {
    getUtente() {
      this.caricaDati();
    },
  },

  computed: {
    GetLoading() {
      return this.$store.getters["app/getLoading"];
    },

    getUtente() {
      return this.$store.getters["user/getNome"];
    },
  },
};
</script>